
import * as React from "react";
import "./ArticleList.scss";
import { ClassableProps, baseClassAnd, childClassClosure, changeSvgToPng } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { Article } from "../../models";
import { RouterLinkProps } from "../../pluggables";

const baseClass = 'article-list';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    articles: Article[];
    /**
     * Pass in the component you use for links.  eg. Link (Gatsby), Link (react-router)
     */
    linkComponent: React.ComponentClass<RouterLinkProps, {}>;
};

/**
 * @deprecated Use <ArticleCards /> it has SASS overrides to control the behaviour
 */
const ArticleList: React.FunctionComponent<Props> = (props: Props) => {
    return <ul className={baseClassAnd(baseClass, props)}>
        {props.articles.map((article, i) => <li key={i} className={childClass('item')}>
            <props.linkComponent to={article.route} className={childClass('image-link')} style={{backgroundImage: `url('${changeSvgToPng(article.mainImage)}')`}}></props.linkComponent>
            <div className={childClass('content')}>
                <h2 className={childClass('title')}><props.linkComponent to={article.route}>{article.title}</props.linkComponent></h2>
                <div className={childClass('info-bar')}>
                <span className={childClass('date')}>{article.dateString}</span> • <span className={childClass('reading-time')}>{article.timeToRead} min read</span>
                </div>
                <p className={childClass('standfirst')}>{article.standfirst}</p>
            </div>
        </li>)}
    </ul>
}
export default ArticleList;